const messages = {
  "title": "Dobrodošli v BRIDGESTONE <span class='text-danger'>PLUS</span>",
  "description": "<b>Imate že račun?</b><br/>Prijavite se z vašim e-naslovom in geslom.<br/><br/><b>Novi ste tu?</b><br/>Če ste nov uporabnik, prosimo registrirajte se.<br/><br/>",
  "info": "",
  "buttons": {
    "action": "Prijavi se / Registriraj se",
    "back": "Nazaj na prijavo",
    "changeLanguage": "Spremeni jezik",
    "start": "Začni"
  },
  "languageSelect": {
    "label": "Izbira jezika",
    "description": "Prosimo izberite vaš jezik"
  }
}

export default {
  messages
}